import {z} from 'zod';

export const GeneralInformationTabFormDefinitionSchema = z.object({
  note: z.string().nullish(),
});

export type GeneralInformationTabFormDefinition = z.infer<
  typeof GeneralInformationTabFormDefinitionSchema
>;
